import React, { useState, useEffect } from "react";
import CardButtonGroup from "../../components/plot_engagement/ActivityCard";
// import PlantingFormIcon from "../../assets/svg/PlantingForm.svg";
import PlantingPopup from "./Popup/PlantingPopup";
import PreparationIconWithTick from "./IconStatus";

const PlantingCardGroup = ({ status, updateStatus, t }) => {
  const [popupType, setPopupType] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const openPopup = queryParams.get("openPopup");

  const setOpenPopupType = () => {
    if (openPopup) {
      setPopupType(openPopup);
    }
  };

  const handleButtonClick = (type) => {
    setPopupType(type);
  };

  useEffect(() => {
    setOpenPopupType();
  }, [openPopup]);

  const closePopup = () => {
    setPopupType(null);
    updateStatus();
  };
  const getActivityStatus = (activity) =>
    status && Array.isArray(status) && status[0]?.[activity];
  const PlantingButtons = [
    {
      label: t("Planting"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("planting")}
          activityType="planting"
        />
      ),
      onClick: () => handleButtonClick("Planting"),
    },
  ];
  return (
    <div>
      <CardButtonGroup buttons={PlantingButtons} t={t} />
      {popupType === "Planting" && <PlantingPopup onClose={closePopup} t={t} />}
    </div>
  );
};

export default PlantingCardGroup;
